export default {
    header: 'Resources',
    resourceTypeHeader: 'Type',
    resourceNoContent: 'Your school has no resources available for you at the moment.',
    resourceFolderNoContent: 'There are no available resources in this folder',
    resourceTitleHeader: 'Title',
    resourcePublishDateHeader: 'Published',
    searchPlaceholder: 'Search for name or keyword ...',

    cvTemplateHeader: 'HIGHERED CV TEMPLATE (ATS-FRIENDLY)',
    cvTemplateSubtitle: 'Download here!',

    noVerifiedSchool: 'You need to verify a school to access school resources.',
    noVerifiedSchoolButton: 'Verify your school',
};
